export default {
    path: '/admin/list',
    component: () => import('@/layout/navication/index.vue'),
    children: [
        {
            path: '/',
            component: () => import('@/pages/admin/list/index.vue')
        }
    ]
};